"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "almenno-san-salvatore": {
    "ff31a147": [{
      "hkey": "45a576c9",
      "slug": "almenno-san-salvatore",
      "name": "Almenno San Salvatore",
      "primary": true,
      "skipSearch": false
    }],
    "almenno-alto": [{
      "hkey": "45a576c9",
      "slug": "almenno-san-salvatore",
      "name": "Almenno San Salvatore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "234312cb": [{
      "hkey": "45a576c9",
      "slug": "almenno-san-salvatore",
      "name": "Almenno San Salvatore",
      "primary": true,
      "skipSearch": false
    }],
    "almenno-basso": [{
      "hkey": "45a576c9",
      "slug": "almenno-san-salvatore",
      "name": "Almenno San Salvatore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;